<h1 mat-dialog-title class="titulo">{{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.TITTULO' | translate}}</h1>
<div>
    <ng-container>
        <div>
            <mat-list-item>
                <div mat-line> <span style="font-weight: bold;">{{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.TO' | translate}}: </span> <span class="information">{{correo}}</span></div>
                <div mat-line><span style="font-weight: bold;">{{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.FROM' | translate}}: </span> <span class="information">non-reply@gptwonline.com</span> </div>
                <div mat-line><span style="font-weight: bold;">{{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.SUBJECT' | translate}}: </span> <span class="information">{{valorAsunto.asunto}}</span> </div>
            </mat-list-item>
            <br>

            <ng-container *ngIf="noHistorial">
                <mat-list style="padding-top: 10px;">
                    <div mat-subheader>
                        <h3 style="font-weight: bold;">{{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.HISTORIAL' | translate}}</h3>

                    </div>
                    <div>
                        <p style="font-weight: bold;">{{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.NOTE' | translate}} {{city_name | translate}}</p>
                    </div>
                    <mat-list-item *ngFor="let folder of historial">
                        <mat-icon mat-list-icon>mark_email_unread</mat-icon>
                        <div mat-line class="delivered" *ngIf="folder.status == 'delivered'"> {{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.ESTATUS' | translate}} <span>{{folder.status}}</span></div>
                        <div mat-line class="processing" *ngIf="folder.status == 'processing'"> {{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.ESTATUS' | translate}} <span>{{folder.status}}</span></div>
                        <div mat-line class="not_delivered" *ngIf="folder.status == 'not_delivered'"> {{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.ESTATUS' | translate}} <span>{{folder.status}}</span></div>
                        <div mat-line>{{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.ABIERTO' | translate}} {{folder.opens_count}} </div>
                        <div mat-line>{{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.ULTIMO_EVENTO' | translate}} {{ folder.last_event_time | date:"d MMM y H:mm":offsetPipe:idiomaActual }} ( {{city_name | translate}} {{folder.last_event_time |date:'O':offsetPipe:idiomaActual
                            }})
                        </div>
                        <!--{{folder.last_event_time}}-->
                    </mat-list-item>
                    <mat-divider></mat-divider>
                </mat-list>
            </ng-container>
            <ng-container *ngIf="!noHistorial">
                <br>
                <div class="alert">
                    <strong>{{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.SIN_CORREOS' | translate}}</strong>
                </div>
            </ng-container> <br> <br>

        </div>
    </ng-container>

</div>

<div fxLayout="row" fxLayoutAlign="center end" mat-dialog-actions>
    <button class="boton" mat-raised-button (click)="onNoClick();">{{'CONSULTATABLA.LOG_SENDGRIND.DIALOG_SENDGRIND.BOTON' | translate}}</button>
</div>